<template>
    <div class="sammio__language_selection">
         <ul v-if="languages !== undefined && languages.length > 0" :aria-label="$t('sammio.dropdown.select_language')">
            <li v-for="(lang, index) in languages" :key="index" :id="'language_'+index" :lang="lang">
              <span 
                v-if="getCurrentLanguage === lang" 
                class="active-lang unselectable"
              > 
                {{ lang.toUpperCase() }}
              </span>
              <span 
                v-else
                class="unselectable"
                role="link"
                tabindex="0"
                :aria-label="$t('sammio.dropdown.change_to_language', {lang: $t('sammio.language.' +  lang)})"
                v-on:click="changeLanguage(lang)"
                @keydown.enter.prevent="changeLanguage(lang)"
              >
                {{ lang.toUpperCase() }}
              </span>
            </li>
        </ul>
    </div>
</template>

<script>
    import { i18n} from "../translations/i18n";

    export default {
        name: "SammioChangeLanguage",
        data() {
            return {
                status: false,
                defaultClass: "dropdown__list list-unstyled",
                languages: {}
            }
        },
        computed: {
            setExpanded() {
                if (this.status) {
                    return "true"
                } else {
                    return "false"
                }
            },
            setClassVisibility() {
                if (this.status) {
                    return ""
                } else {
                    return "hide"
                }
            },
            getCurrentLanguage() {
                return i18n.locale
            }
        },
        methods: {
            changeLanguage(lang) {
                if (lang !== i18n.locale) {
                    i18n.locale = lang
                    let routeQuery = {}
                    if (lang !== 'fi') {
                        routeQuery.lang = lang
                    }
                    this.$router.push({
                        name: this.$router.currentRoute.name,
                        query: routeQuery
                    })
                    jQuery('html').focus();

                    // If cookie banner answer has not been given force page reload to load correct language banner
                    if (!this.getCookie('yja_cookie_acceptance')) {
                        window.location.reload();
                    }
                }
            },
            a11yDropdown(event) {
                    const KEY = event.key
                     switch (KEY) {
                        case "ArrowDown":
                            this.a11yMoveOnList('down' )
                            break;
                        case "ArrowUp":
                            this.a11yMoveOnList('up')
                            break;
                    }

            },
            a11yMoveOnList(direction) {

                const focussable = Array.prototype.slice.call(this.$refs.dropdownListContainer.querySelectorAll("a"))
                const lastFocusable = focussable[focussable.length - 1];
                const firstFocusable = focussable[0]

                let current = focussable.indexOf(document.activeElement);

                if (direction === 'down') {

                    if (current < focussable.indexOf(lastFocusable)){
                        let nextElement = focussable[current + 1]

                        nextElement.focus()
                    }
                } else {
                    if (focussable.indexOf(firstFocusable) <  current) {
                        let prevElement = focussable[current - 1]

                        prevElement.focus()
                    }
                }
            },
            getCookie(name) {
              var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
              if (match) return match[2];
              else return null;
            }
        },
        watch: {
            status: function(newVal,oldVal) {
                const button = this.$refs.dropdownButton
                const dropdown = this.$refs.dropdownListContainer

                if (newVal === true) {
                    dropdown.setAttribute('tabIndex','1')
                    button.addEventListener('keydown', (event) => {

                        if (event.key === 'ArrowDown' && button === document.activeElement) {
                                const children = dropdown.querySelectorAll('a')
                                children[0].focus()
                            }
                        },false)

                } else {
                    dropdown.setAttribute('tabIndex','-1')
                }
            }
        },
        mounted() {
            window.addEventListener('load', () => {
                this.languages = ['fi', 'sv']
                if (this.$root.enEnabled) {
                    this.languages.push('en')
                }
            })
          window.addEventListener('resize', () => {
            this.languages = ['fi', 'sv']
            if (this.$root.enEnabled) {
              this.languages.push('en')
            }
          })

        }
    }
</script>

<style scoped>

</style>
